import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import ErrorMessage from "../../../../components/comman/ErrorMessage";
import LocationIcon from "../../../../components/Icons/LocationIcon";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import MapComponent from "../../../../components/comman/MapComponent";

export default function AddOffice() {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const earningRef = useRef(null);
  const deductionRef = useRef(null);
  // console.log("location>>>>>>>>>>>", location?.state);
  const apiKey = import.meta.env.VITE_APP_API_KEY;
  const [mapCenter, setMapCenter] = useState({ lat: 28.0229, lng: 73.3119 });
  const [markers, setMarkers] = useState([{ lat: 28.0229, lng: 73.3119 }]);
  const [circleRadius, setCircleRadius] = useState(0);
  const [selectedSalaryHeads, setSelectedSalaryHeads] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const [pageStates, setPageStates] = useState({
    siteList: [],
    earnings: [],
    deductions: [],
    siteSalaryHeadDetail: [],
    isLoading: false,
  });

  useEffect(() => {
    GetCompanyList();
    GetSalaryHead("earning");
    GetSalaryHead("deduction");
    if (location?.state?.data) {
      GetSalaryHeadDetail();
    }

    if (location?.state?.data) {
      const locationData =
        typeof location?.state?.data?.location === "string"
          ? JSON.parse(location?.state?.data?.location)
          : location?.state?.data?.location;

      const latitude = parseFloat(locationData?.lat);
      const longitude = parseFloat(locationData?.lng);
      const range = parseFloat(location?.state?.data?.range);

      setMapCenter({ lat: latitude, lng: longitude });
      setMarkers([{ lat: latitude, lng: longitude }]);
      setCircleRadius(range);

      setTimeout(() => {
        reset({
          name: location?.state?.data?.name || "",
          companyId: location?.state?.data?.companyId || "",
          address: location?.state?.data?.address || "",
          range: location?.state?.data?.range || 0,
          lat: latitude,
          lng: longitude,
        });
      }, 1000);
    } else {
    }
  }, []);

  const getCoordinates = () => {
    const address = getValues("address");
    if (!address) {
      toast.error("Please enter an address to search coordinates.");
      return;
    }
    setIsLoadingAddress(true);
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${apiKey}`;

    fetch(geocodeUrl)
      .then((res) => res.json())
      .then((data) => {
        setIsLoadingAddress(false);
        if (data?.status === "OK" && data?.results?.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;

          // Autofill lat/lng fields
          setValue("lat", lat);
          setValue("lng", lng);

          // Update map center and marker
          setMapCenter({ lat, lng });
          setMarkers([{ lat, lng }]);
          toast.success("Coordinates fetched successfully!");
        } else {
          toast.error("Unable to find coordinates for the entered address.");
        }
      })
      .catch(() => {
        toast.error("Error fetching coordinates. Please try again.");
      });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_company;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setCompanyList(response?.data?.company);
      }
    });
  };

  const GetSalaryHead = (type) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_salary_head + `pageSize=50&type=${type}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          ...(type === "earning" && { earnings: res?.data?.salaryHead }),
          ...(type === "deduction" && { deductions: res?.data?.salaryHead }),
        }));
      }
    });
  };

  const GetSalaryHeadDetail = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_site_salary_head_detail +
      `?siteId=${location?.state?.data?.id}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        const mappedHeads = res.data.map((item) => ({
          id: item.salaryhead.id,
          name: item.salaryhead.name,
          type: item.salaryhead.type,
        }));

        setSelectedSalaryHeads(mappedHeads);
      }
    });
  };

  const handleSelectSalaryHead = (item) => {
    // console.log("item in handleselect===>", item);
    if (!selectedSalaryHeads.some((i) => i.id === item.id)) {
      setSelectedSalaryHeads((prev) => [...prev, item]);
    }
  };

  const handleRemoveSalaryHead = (id) => {
    setSelectedSalaryHeads((prev) => prev.filter((item) => item.id !== id));
  };

  const onSubmit = (data) => {
    const cords = {
      lat: data?.lat,
      lng: data?.lng,
    };

    let formData = new FormData();
    formData.append("name", data?.name);
    formData.append("companyId", data?.companyId);
    formData.append("address", data?.address);
    formData.append("location", JSON.stringify(cords));
    formData.append("range", data?.range);
    if (!location?.state?.data) {
      formData.append("type", "office");
    }

    const options = {
      method: "POST",
      form_data: formData,
    };

    if (location?.state?.data) {
      let API = apiUrl?.update_site + `?siteId=${location?.state?.data?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      let API = apiUrl?.add_site;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (
    <>
      <>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row align-items-center row-gap-3">
            <div className="content-head mb-5 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-start gap-4">
                <button
                  type="button"
                  className="btn back-arrow"
                  onClick={() => navigate(-1)}
                >
                  <BackArrowIcon />
                </button>
                <h1 className="mb-0">
                  {location?.state?.data ? "Update" : "Add"} Office
                </h1>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="col-12 mb-4">
                  <h4>Office Location</h4>
                  <MapComponent
                    apiKey={apiKey}
                    center={mapCenter}
                    markers={markers}
                    circleRadius={circleRadius || 0}
                    onMarkerDragEnd={(position) => {
                      // Update the form values and map state with new position
                      setValue("lat", position.lat);
                      setValue("lng", position.lng);
                      setMapCenter({ lat: position.lat, lng: position.lng });
                      setMarkers([{ lat: position.lat, lng: position.lng }]);
                    }}
                  />
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-group mb-3">
                          <label htmlFor="cardId" className="form-label">
                            Office Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="cardId"
                            {...register("name", {
                              required: "This field is Required",
                            })}
                          />
                          <ErrorMessage message={errors?.name?.message} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-group mb-3">
                          <label className="form-label">Company</label>
                          <select
                            className="form-select form-control"
                            {...register("companyId", {
                              required: "Please select a company",
                            })}
                          >
                            <option value="" className="d-none">
                              Select Company
                            </option>
                            {companyList?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage message={errors?.companyId?.message} />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <div className="form-group mb-3">
                        <label htmlFor="shiftTime" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="description"
                          rows={3}
                          defaultValue={""}
                          {...register("address", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.address?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 d-flex align-items-center  justify-content-center">
                      <button
                        className="btn btn-primary w-auto"
                        type="button"
                        onClick={getCoordinates}
                      >
                        <LocationIcon />{" "}
                        {isLoadingAddress ? <Spinner /> : "Get Coordinates"}
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className="form-group mb-3">
                        <label htmlFor="lat" className="form-label">
                          Latitude
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="lat"
                          disabled
                          value={
                            watch("lat") ? Number(watch("lat")).toFixed(4) : ""
                          }
                          {...register("lat", {
                            required: "This field is Required",
                            setValueAs: (value) => Number(value).toFixed(4), // Ensure saved value is fixed to 4 decimals
                          })}
                        />
                        <ErrorMessage message={errors?.lat?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className="form-group mb-3">
                        <label htmlFor="lng" className="form-label">
                          Longitude
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="lng"
                          disabled
                          value={
                            watch("lng") ? Number(watch("lng")).toFixed(4) : ""
                          }
                          {...register("lng", {
                            required: "This field is Required",
                            setValueAs: (value) => Number(value).toFixed(4), // Ensure saved value is fixed to 4 decimals
                          })}
                        />
                        <ErrorMessage message={errors?.lng?.message} />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <div className="form-group mb-3">
                        <label htmlFor="range" className="form-label">
                          Range (in mtr)
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          id="range"
                          {...register("range", {
                            required: "This field is Required",
                            valueAsNumber: true,
                          })}
                          onChange={(e) => {
                            const newRange = Number(e.target.value);
                            setCircleRadius(newRange);
                          }}
                        />
                        <ErrorMessage message={errors?.range?.message} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row my-5">
              <h4 className="mb-3">Office Salary (Earnings, Deductions)</h4>
                <div className="col-12 col-md-6 mb-4">
                  <div className="border rounded p-3 h-100 bg-success-subtle">
                    <h4 className="text-center mb-3">Earnings</h4>

                    <select
                      className="form-select mb-3"
                      ref={earningRef}
                      onChange={(e) => {
                        const selected = pageStates?.earnings?.find(
                          (item) => item?.id === e.target.value
                        );
                        selected &&
                          handleSelectSalaryHead({
                            ...selected,
                            type: "earning",
                          });
                        if (earningRef.current) {
                          earningRef.current.value = "";
                        }
                      }}
                    >
                      <option value="">Select Earning</option>
                      {pageStates?.earnings?.map((item) => {
                        const isSelected = selectedSalaryHeads.some(
                          (selected) => selected.id === item.id
                        );
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                            disabled={isSelected}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                    </select>

                    <div className="d-flex flex-column gap-2">
                      {selectedSalaryHeads.filter(
                        (item) => item?.type === "earning"
                      ).length === 0 ? (
                        <div className="text-muted text-center fst-italic">
                          No earnings selected
                        </div>
                      ) : (
                        selectedSalaryHeads
                          .filter((item) => item?.type === "earning")
                          .map((item) => (
                            <div
                              className="border rounded px-3 py-2 d-flex justify-content-between align-items-center bg-light mx-2"
                              key={item?.id}
                            >
                              <span>{item?.name}</span>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => handleRemoveSalaryHead(item?.id)}
                              ></button>
                            </div>
                          ))
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-4">
                  <div className="border rounded p-3 h-100 bg-danger-subtle">
                    <h4 className="text-center mb-3">Deductions</h4>

                    <select
                      className="form-select mb-3"
                      ref={deductionRef}
                      onChange={(e) => {
                        const selected = pageStates?.deductions?.find(
                          (item) => item?.id === e.target.value
                        );
                        selected &&
                          handleSelectSalaryHead({
                            ...selected,
                            type: "deduction",
                          });
                        if (deductionRef.current) {
                          deductionRef.current.value = "";
                        }
                      }}
                    >
                      <option value="">Select Deduction</option>
                      {pageStates?.deductions?.map((item) => {
                        const isSelected = selectedSalaryHeads.some(
                          (selected) => selected.id === item.id
                        );
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                            disabled={isSelected}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                    </select>

                    <div className="d-flex flex-column gap-2">
                      {selectedSalaryHeads.filter(
                        (item) => item?.type === "deduction"
                      ).length === 0 ? (
                        <div className="text-muted text-center fst-italic">
                          No deductions selected
                        </div>
                      ) : (
                        selectedSalaryHeads
                          .filter((item) => item?.type === "deduction")
                          .map((item) => (
                            <div
                              className="border rounded px-3 py-2 d-flex justify-content-between align-items-center bg-light mx-2"
                              key={item?.id}
                            >
                              <span>{item?.name}</span>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => handleRemoveSalaryHead(item?.id)}
                              ></button>
                            </div>
                          ))
                      )}
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="d-flex align-items-center justify-content-end gap-4 my-4">
                <button
                  className="btn btn-secondary px-4"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary px-4" type="submit">
                  {isLoading ? <Spinner /> : location?.state ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </>
    </>
  );
}
